<template>
  <nav>
    <ul class="questions-section__list">
      <li v-for="step in steps" :key="step.index">
        <span class="step-item" :class="{ 'active-step': isActiveStep(step) }">
          <span v-if="!step.hideIndex">Step {{ step.index }} </span>
          {{ step.name }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStepsStore } from "@/stores/new/steps.store";
import { useRoute } from "vue-router";

const route = useRoute();
const stepsStore = useStepsStore();
const steps = computed(() => stepsStore.steps);

const isActiveStep = (step) => route.path === step.path;
</script>

<style scoped>
.questions-section__list {
  display: grid;
  row-gap: 20px;
  margin-bottom: 30px;
}

.questions-section__list .step-item {
  position: relative;
  color: #404d63;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  padding-left: 0;
  transition: 0.5s ease;
}

.questions-section__list .step-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #2491eb;
  opacity: 0;
  transition: 0.5s ease;
}

.questions-section__list .step-item.active-step {
  color: #2491eb;
  padding-left: 20px;
  transition: 0.5s ease;
}

.questions-section__list .step-item.active-step:before {
  opacity: 1;
  transition: 0.8s ease;
}

.questions-section__list .step-item span {
  font-weight: 400;
}
</style>
